import { render } from "./Calendar.vue?vue&type=template&id=5753b66a&scoped=true"
import script from "./Calendar.vue?vue&type=script&lang=js"
export * from "./Calendar.vue?vue&type=script&lang=js"

import "./Calendar.vue?vue&type=style&index=0&id=5753b66a&lang=scss&scoped=true"
import "./Calendar.vue?vue&type=style&index=1&id=5753b66a&lang=scss&global=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5753b66a"]])

export default __exports__